module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/timer-6c43d3d2f61ecb613159352b6c437806.svg";